import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TrackingSummary } from "services/asset-management/AssetService";

interface TrackingSummaryState {
    trackingSummary: TrackingSummary | null;
}

const INITIAL_STATE: TrackingSummaryState = {
    trackingSummary: null,
};

const TRACKING_SUMMARY_SLICE = createSlice({
    name: "trackingSummaryStore",
    initialState: INITIAL_STATE,
    reducers: {
        setTrackingSummary(state, action: PayloadAction<TrackingSummary>) {
            state.trackingSummary = action.payload;
        },
        clearTrackingSummary(state) {
            state.trackingSummary = null;
        },
    },
});

export const { setTrackingSummary, clearTrackingSummary } = TRACKING_SUMMARY_SLICE.actions;

export default TRACKING_SUMMARY_SLICE.reducer;
